
import NavItems from '../Header/NavItems.json'
import { mapGetters } from 'vuex'
import CheckMobileApp from '~/mixins/CheckMobileApp'
export default {
  mixins: [CheckMobileApp],
  data() {
    return {
      navItems: NavItems,
      types: [],
      activeMenu: [],
      myProfile: [],
    }
  },
  watch: {
    $route: {
      handler() {
        this.activeMenu = []
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  mounted() {
    this.types = NavItems.find((item) => item.title === 'nav.products').sub
    this.myProfile = NavItems.find((item) => item.title === 'nav.myprofile').sub
  },
}
